import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { BaseNavigationGuard } from './base-navigation.guard';
import { MenuIdentifiers } from 'core/services/navigation.service';
import { Role } from 'shared/constants/role';

@Injectable({
  providedIn: 'root',
})
export class CanActivateSiteConfiguration extends BaseNavigationGuard implements CanActivate {
  public canActivate(): boolean {
    return this.canAccessRoute(MenuIdentifiers.SITE_SETTINGS, [Role.SiteAdmin]);
  }
}
